export default __webpack_public_path__ + "static/media/signTopicMap.7b9d1979.png";